<template>
  <v-layout>
    <v-app-bar
      app
      absolute
      height="60"
      :elevation="1"
    >
      <v-img
        :src="appLogo"
        max-height="30px"
        max-width="30px"
        alt="logo"
        contain
        class="me-3"
      />

      <h2 class="text-2xl font-weight-semibold text-uppercase">
        VikFlow
      </h2>

      <v-spacer></v-spacer>

      <h3 class="text-header mr-15 text-2xl font-weight-semibold text--primary">
        CENTRAL DE ATENDIMENTO
      </h3>

      <v-spacer class="mr-15"></v-spacer>

      <app-bar-user-menu v-if="isLoggedIn"></app-bar-user-menu>
    </v-app-bar>
  </v-layout>
</template>

<script>
import themeConfig from '@themeConfig'
import AppBarUserMenu from '@core/layouts/components/app-bar/AppBarUserMenu.vue'
import { storeToRefs } from 'pinia'
import { computed } from '@vue/composition-api'
import useAuthStore from '@/store/auth'

export default {
  components: {
    AppBarUserMenu,
  },
  props: {
    logoEmpresa: {
      type: String,
      required: false,
      default: null,
    },
  },

  setup(props) {
    const { isLoggedIn } = storeToRefs(useAuthStore())

    const appLogo = computed(() => {
      if (props.logoEmpresa) return props.logoEmpresa
      return themeConfig.app.logo
    })

    return {
      isLoggedIn,
      appLogo,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/pages/auth.scss';

@media (max-width: 1000px) {
  .text-header {
    display: none;
  }
}
</style>
